import customSizeCharts from "./customSizeCharts";
import customSizeChartsWithId from "./customSizeChartsWithId";

export default { ...customSizeCharts, ...customSizeChartsWithId };
